import api from '../services/api';
import swal from 'sweetalert2';
import AdminApi from "../services/api";
import Loc from "../services/localization";

/* init */
const AdminApiService = new AdminApi()
const LocService = new Loc()


export default{

    props: ['show', 'image', 'userId'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            imageUrl: '',
            showImage: false,
            selectedImage: null,
            selectedImagePreview: null
        };
    },
    watch: {
        show: function(val, oldVal) {
            if(val){
                this.isLoading = false;
                this.selectedImage = null;
                this.selectedImagePreview = null;
                this.showImage = this.image.length > 0
                this.imageUrl = this.image;
            }

        },
    },
    methods: {
        loadTextFromFile: loadTextFromFile,
        uploadImage: uploadImage,
        close() {
            this.$topnavbar.$emit('closeShowImage')
            this.imageUrl = '';
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--medium'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: #1C242D;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important;';
            }
            return 'height: 600px !important;';
        }

    }
}

function uploadImage(){
    let _self = this;
    _self.isLoading = true;
    AdminApiService.uploadImage(this.userId, this.selectedImage)
        .then((response) => {
            _self.isLoading = false;
            _self.show = false;
        })
        .catch((error) => {
            _self.isLoading = false;
            _self.hasError = _self.locale.t('label_image_upload_error')
        })
}

function loadTextFromFile(ev){
    var i = 0;
    for(i = 0; i< ev.target.files.length; i++){
        const file = ev.target.files[i];
        if(file.size > 5000000){
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }

}



// WEBPACK FOOTER //
// ./src/modals/ShowImageModal.js